//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "bottom",
  methods:{
    clickItem:function(path){
        this.$router.push(path);
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/foort.vue